<template>
  <v-app id="inspire">
    <v-container class="bckcolor" fluid>
        
        <v-layout row wrap>
                  <v-flex xs12 sm12 md4></v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-container>
                      
                    <v-card class="login-container elevation-10">
                      <!-- <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear> -->
                    <v-form class="login-form" ref="form" v-model="valid" lazy-validation>
                     <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                         <div class="call-button-container" style="margin-bottom:20px">
                           <img style="height: 60px;" src="../../assets/logo.png">
                         </div>
                       </v-flex>

                     
                       <v-flex xs12 sm12 md12>
                          <v-text-field
                          v-model="form.fullName"
                          append-icon="person"
                          label="Your Fullname"
                          type="text"
                          :rules="[rules.required]"
                          required
                          ></v-text-field>
                       </v-flex>

                       <v-flex xs12 sm12 md12 style="margin-top: -10px;">
                          <v-text-field
                          v-model="form.email"
                          append-icon="mark_email_read"
                          label="Email ID"
                          type="text"
                          :rules="[rules.emailid]"
                          required
                          ></v-text-field>
                       </v-flex>

                       <v-flex xs12 sm12 md12 style="margin-top: -10px;">
                          <v-text-field
                          v-model="form.mobileNumber"
                          append-icon="call"
                          label="Mobile number"
                          type="number"
                          min="0"
                          :rules="[rules.mobileno]"
                          required
                          style="font-size: 10px;"
                          ></v-text-field>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="margin-top: -10px;">
                         <v-text-field
                           v-model="form.passwords"
                           :append-icon="passwordShow ? 'visibility_off' : 'visibility'"
                           :type="passwordShow ? 'text' : 'password'"
                           @click:append="passwordShow = !passwordShow"
                           name="password"
                           label="Password"
                           :rules="[rules.required, rules.min, rules.number, rules.capital, rules.small, rules.spec]"
                           required
                         ></v-text-field>
                       </v-flex>

                       <v-flex xs12 sm12 md12>
                          <v-btn
                          style="background-image: linear-gradient(-150deg, #F78163, #F78163);margin-bottom:20px;margin-top:20px"
                            
                            large
                            block
                            depressed
                            color="primary"
                            :loading="svBtn"
                            class="white--text"
                            @click="onSubmit()"
                          >
                            SUBMIT
                          </v-btn>
                       </v-flex>
                       <v-flex xs12 style="text-align:center">
                         <span class="blue--text cursr txt_dec" @click="back()">Back to the log in page</span>
                       </v-flex>
                       
                     </v-layout>
                 </v-form>
                 </v-card>
                 </v-container>
                 
                  </v-flex>
              </v-layout>
      </v-container>

    <!-- <v-footer class="black--text pa-4" style="background-color:white">
      <v-spacer></v-spacer>
      <div class="black--text">
        &copy; {{ new Date().getFullYear() }} Developed with 💖 by
        <a
          href="http://infosyst.in/"
        >Infosyst</a>
       
      </div>&nbsp;&nbsp;&nbsp;&nbsp;
    </v-footer> -->
  </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data: () => ({
    loading: false,
    menu: false,
    dialog: false,
    drawer: null,
    svBtn: false,
    valid: true,
    passwordShow: false,

    form: {
      fullName: null,
      mobileNumber: null,
      email: null,
      passwords: null
    },

    rules: {
        required: value => !!value || "Required.",
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
        emailid: value => {
          const pattern = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          return pattern.test(value) || "Email Id is not valid!!";
        },
        min: value =>
          (value != null && value.length >= 6) || "Min 6 characters",
        number: value => {
          const pattern = /[0-9]+/;
          return pattern.test(value) || "Min one number";
        },
        capital: value => {
          const pattern = /[A-Z]+/;
          return pattern.test(value) || "Min one capital letter";
        },
        small: value => {
          const pattern = /[a-z]+/;
          return pattern.test(value) || "Min one small letter";
        },
        spec: value => {
          const pattern = /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~ ]+/;
          return pattern.test(value) || "Min one special character";
        }
      },
  }),
  props: {
    source: String
  },

  methods: {
    back() {
      this.$router.push("/login");
    },
    emobile() {
      this.$router.push("/emobile");
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.svBtn = true;
        this.axios
          .post(
            config.API + `Register`,
            {
              fullName: this.form.fullName,
              email: this.form.email,
              mobileNumber: this.form.mobileNumber,
              passwords: this.form.passwords
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully Registered");
            this.$router.push("/login");
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }

  }

};
</script>

<style lang="css" scoped>
.login-container {
  border-radius: 10px !important;
  border: 1px solid !important;
  border-color: #f78163 !important;
}
.login-form {
  padding: 40px;
  height: auto;
}
.bckcolor {
  /* background-image: linear-gradient(-90deg, #b41d56, #280071); */
  background-image: linear-gradient(-150deg, #FAF8ED, #FAF8ED);
  background-size: cover;
}
.cursr {
  cursor: pointer;
}
.v-btn {
  margin-left: 0px;
}
.txt_dec:hover {
    text-decoration: underline !important;
}
/* .centeredd {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;
} */
/* .loginPage {
  background-image: url('../../assets/slider_2.jpg');
  background-size:cover
} */
.call-button-container {
  margin: auto;
  width: 233px;
  height: 74px;
  vertical-align: middle;
  
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
/* .pos {
  position: absolute;
  top: 0;
  right: 10px;
  z-index: 999;
} */
</style>
